import { render, staticRenderFns } from "./PurchaseWizard.vue?vue&type=template&id=7cbf6180&"
import script from "./PurchaseWizard.vue?vue&type=script&lang=js&"
export * from "./PurchaseWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports